import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { dropdownAnimation } from '../../../animations/dropdown.animation';
import { TreeControlService } from '../tree-control.service';
import { TreeNode } from '../tree-node';


@Component({
  selector: 'red-virtual-tree-item',
  templateUrl: './virtual-tree-item.component.html',
  styleUrls: ['./virtual-tree-item.component.scss'],
  animations: [dropdownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VirtualTreeItemComponent implements OnInit {
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  public hasChild: boolean;
  @Input() public expanded: boolean;

  private _node: TreeNode;
  private _checked: boolean;
  private _indeterminate: boolean;
  
  @Input() set node(node: TreeNode) {
    this._node = node;
    this.hasChild = node.expandable;
  }

  get node(): TreeNode {
    return this._node;
  }


  @Input() set checked(checked: boolean) {
    this._checked = checked;
  }

  get checked(): boolean {
    return this._checked;
  }


  @Input() set indeterminate(indeterminate: boolean) {
    this._indeterminate = indeterminate;
  }

  get indeterminate(): boolean {
    return this._indeterminate;
  }

  constructor(public treeControl: TreeControlService) { }

  ngOnInit() {
  }
}
